export default __webpack_public_path__ + "static/media/duelbits.80daf2de.svg";